import { IRelatedProduct } from 'models/BasicProduct';
import { GTM_LIST_NAME } from 'store/googleTagManager/types';
import { ListViewProduct } from 'models/ListViewProduct';
import { mapUrlToCategories } from 'store/googleTagManager/events/utils';

export const getAccessoryListName = (product: IRelatedProduct): string => {
  const { productId, title } = product;
  return `${GTM_LIST_NAME.ACCESSORY} | ${productId} - ${title}`;
};

export const getTopSellerListName = (product: ListViewProduct): string => {
  const { productId, title } = product;
  return `${GTM_LIST_NAME.TOP_SELLER} | ${productId} - ${title}`;
};

export const getSeriesProductListName = (product: ListViewProduct): string => {
  const { productId, title } = product;
  return `${GTM_LIST_NAME.SERIES_PRODUCT} | ${productId} - ${title}`;
};

export const getEditorialProductListName = (heading: string): string => {
  const formattedHeading = heading.toLowerCase().replaceAll(' ', '_');
  return `${GTM_LIST_NAME.REPORTS_GUIDES} | ${formattedHeading}`;
};

export const getOthersAlsoBoughtListName = (product: ListViewProduct): string => {
  const { productId, title } = product;
  return `${GTM_LIST_NAME.OTHERS_ALSO_BOUGHT} | ${productId} - ${title}`;
};

export const getProductListName = (webCatalog: string, productUrl: string): string => {
  const categoryUrl = mapUrlToCategories(productUrl).join('/');
  return `${GTM_LIST_NAME.PRODUCT_LIST} | ${webCatalog} - ${categoryUrl} `;
};

export const getBrandListName = (webCatalog: string, brandName?: string): string => {
  return `${GTM_LIST_NAME.BRAND} | ${webCatalog} - ${brandName} `;
};

export const getSearchPageListName = (searchPhrase: string): string => {
  return `${GTM_LIST_NAME.SEARCH_PAGE} | ${searchPhrase}`;
};

export const getSponsoredListName = (title: string): string => {
  return `${GTM_LIST_NAME.SPONSORED} | ${title}`;
};

export const getAddonListName = (productId: string, productTitle: string): string => {
  return `${GTM_LIST_NAME.ADDON} | ${productId} - ${productTitle}`;
};

export const getCartRecommendationListName = (productId: string, productTitle: string): string => {
  return `${GTM_LIST_NAME.CART_RECOMMENDATIONS} | ${productId} - ${productTitle}`;
};

export const getLastViewedListName = (productId: string, productTitle: string): string => {
  return `${GTM_LIST_NAME.LAST_VIEWED} | ${productId} - ${productTitle}`;
};

export const getCampaignPageListName = (productId: string, productTitle: string): string => {
  return `${GTM_LIST_NAME.CAMPAIGN_PAGE} | ${productId} - ${productTitle}`;
};
